import { Container, Button, Form, Collapse } from "react-bootstrap";
import { ImSortAlphaAsc, ImSortAlphaDesc } from "react-icons/im";
import { BsChevronDown } from "react-icons/bs";
import { MdNavigateNext } from "react-icons/md";
import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import IconButton from "../../common/IconButton";
import getDatos from "../../../services/getDatos";
import Card from "../card/Card";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Secciones from "../combos/Secciones";
import Tematicas from "../combos/Tematicas";
import encode64 from "../../../helpers/encode64";
import decode64 from "../../../helpers/decode64";
import { Pagination } from "../../common/Pagination";

// componentes
import Load from "../../common/Load";

// context
import contextGeomedellin from "../../../context/contextGeomedellin";

// hooks react router
import { useSearchParams } from "react-router-dom";

// custom hooks
import { usePermisions } from "../../../hooks/usePermisions";

export default function Search({
  position,
  caractFiltro,
  element,
  fraseCorta,
  setDataBuscadorHori,
  setTotalRowsGlobal,
  rowPerPage,
}) {
  const [searchParams] = useSearchParams();
  const { permissions, infoUser } = usePermisions(element);
  const [tipoConsultaGrupos, setTipoConsultaGrupos] = useState(
    () => {
      let datos;
      if (localStorage.getItem("superAdmin") === "true") {
        datos = caractFiltro.resultGruposSubGruposSuperAdmin;
      } else {
        if (element === 3) {
          datos = caractFiltro.resultGruposSubGruposDocumentacion;
        } else if (element === 1) {
          datos = caractFiltro.resultGruposSubGruposGeoservicios;
        } else if (element === 7) {
          datos = caractFiltro.resultGruposSubGruposNoticias;
        } else if (element === 5) {
          datos = caractFiltro.resultGruposSubGruposAplicaciones;
        } else if (element === 2) {
          datos = caractFiltro.resultGruposSubGruposDatosAbiertos;
        } else {
          datos = caractFiltro.resultGruposSubGrupos;
        }
      }
      return datos;
    }
    // localStorage.getItem("superAdmin") === "true"
    //   ? caractFiltro.resultGruposSubGruposSuperAdmin
    //   : caractFiltro.resultGruposSubGrupos
  );

  const { buscadorHoriBool, setBuscadorHoriBool } =
    useContext(contextGeomedellin);

  const [currentPage, setCurrentPage] = useState(1);

  const [typeEvent, setTypeEvent] = useState("");

  const [totalRowsPagination, setTotalRowsPagination] = useState(1);

  const [objectBuscador, setObjectBuscador] = useState({
    comp: element,
    page: currentPage,
    min: element === 0 ? 0 : currentPage * rowPerPage - rowPerPage,
    max: rowPerPage,
    element: !searchParams.get("id") ? null : searchParams.get("id"),
    filtros: encode64(
      JSON.stringify(
        position !== "vertical"
          ? [{ Secciones: [] }, { Tematicas: [] }, { Orden: [2] }]
          : [
              { Tipo: [] },
              {
                Tematicas: [
                  !searchParams.get("idTematica")
                    ? null
                    : searchParams.get("idTematica"),
                ],
              },
              { Orden: [2] },
              { Reciente: [1] },
              { Formatos: [] },
              { Categoria: [] },
              { Fechas: [] },
              { Grupos: [] },
              { Activos: [] },
              { SubGrupos: [] },
            ]
      )
    ),
    texto: "",
    superAdmin: localStorage.getItem("superAdmin"),
    idUsuario: infoUser,
    entrada: 0,
  }); //objeto con parametros del buscador
  // Load
  const [load, setLoad] = useState(false);

  const [ordenar, setOrdenar] = useState(false); //estado para mostrar las opciones de ordenar

  //buscador vertical
  const [buscadorVert, setBuscadorVert] = useState([]);
  const [rotate, setRotate] = useState(false); //estado para manejar el rotate de tipo
  const [rotateGrupos, setRotateGrupos] = useState(false); //estado para manejar el rotate de tipo
  const [tema, setTema] = useState("Tipo"); //estado del tema principal del filtro
  //buscador vertical para grupos, subgrupos y activos
  const [temaActivos, setTemasActivos] = useState(""); //estado para manejar si el grupo es activo o no
  const [temaSubGrupos, setTemaSubGrupos] = useState(""); //estado para manejar los subgrupos
  const [temaGrupos, setTemaGrupos] = useState(""); //estado para manejar los grupos
  const [rotateActivos, setRotateActivos] = useState(false); //estado para manejar el rotate de tipo
  const [rotateSubGrupos, setRotateSubGrupos] = useState(false); //estado para manejar el rotate de tipo

  const [rotateTematica, setrotateTematica] = useState(false); //estado para manejar el evento rotate de

  //estados de propiedades del buscador
  const [temticaFiltro, setTemticaFiltro] = useState([]);
  const [tipofiltro, setTipofiltro] = useState([]);
  const [tipofiltroGrupos, setTipofiltroGrupos] = useState([]);
  const [tipofiltroActivos, setTipofiltroActivos] = useState([]);
  const [tipofiltroSubGrupos, setTipofiltroSubGrupos] = useState([]);
  const [tipofiltroSubGruposFiltrada, setTipofiltroSubGruposFiltrada] =
    useState([]);
  const [reRender, setreRender] = useState(0);

  const [fechaFiltro, setFechaFiltro] = useState([]);

  function handleLoad(cargando) {
    setLoad(cargando);
  }

  //función encargada de limpiar los campos del buscador
  function limpiarFiltros() {
    document.getElementById("inp-search-v").value = "";
    let element_check_filtros =
      document.getElementsByClassName("form-check-input");
    for (let i = 0; i < element_check_filtros.length; i++) {
      if (element_check_filtros[i].checked) {
        element_check_filtros[i].checked = false;
      }
    }
    setCurrentPage(1);

    setObjectBuscador({
      ...objectBuscador,
      element: null,
      comp: element,
      page: 1,
      min: currentPage * rowPerPage - rowPerPage,
      max: rowPerPage,
      filtros: encode64(
        JSON.stringify(
          position !== "vertical"
            ? [{ Secciones: [] }, { Tematicas: [] }, { Orden: [] }]
            : [
                { Tipo: [] },
                { Tematicas: [] },
                { Orden: [] },
                { Reciente: [] },
                { Formatos: [] },
                { Categoria: [] },
                { Fechas: [] },
                { Grupos: [] },
                { Activos: [] },
                { SubGrupos: [] },
              ]
        )
      ),
      texto: "",
      idUsuario: infoUser,
      superAdmin: localStorage.getItem("superAdmin"),
    });
    setTipofiltroSubGruposFiltrada([]);
  }

  //función encargada de setear los volores seleccionados en los filtros
  async function changeSearchSetVal(e, positionSearch, component, nroFiltro) {
    setTypeEvent(e.type);
    let filtrosDecod = JSON.parse(decode64(objectBuscador.filtros));
    //se valida la existencia del evento
    try {
      if (e || e === 0) {
        if (positionSearch === "vertical") {
          //se valida la posición del buscador
          if (nroFiltro !== 3 && nroFiltro !== 4) {
            if (e.target.checked) {
              // se valida que el filtro que venga esté checkeado
              let dato =
                nroFiltro !== 0
                  ? JSON.parse(decode64(e.target.value))
                  : e.target.checked;
              let id;
              let tematicaCk;
              let nameKey;
              let nameKeyGrupos;
              if (nroFiltro === 1) {
                id =
                  tema === "Tipo"
                    ? dato.id_tipo
                    : tema === "Formatos"
                    ? dato.id_tipo_formato
                    : tema === "Categoría"
                    ? dato.id_categoria
                    : tema === "Fechas"
                    ? dato.id_filtro
                    : "";

                // if (id === "" && temaGrupos === "Grupos") {
                if (temaGrupos === "Grupos" && dato.id_grupo) {
                  nameKeyGrupos = "Grupos";
                  id = dato.id_grupo;

                  if (!id) {
                    if (!id) {
                      id = dato.activos;
                    }
                    if (id === undefined) {
                      id = dato.id_modulo;
                      filtrosDecod[9].SubGrupos.push(id);
                    } else {
                      filtrosDecod[8].Activos.push(id);
                    }
                  } else {
                    filtrosDecod[7].Grupos.push(id);
                  }
                }
                if (typeof dato.activos !== "undefined") {
                  id = dato.activos;
                  filtrosDecod[8].Activos.push(id);
                }
                if (typeof dato.id_grupo_padre !== "undefined") {
                  id = dato.id_modulo;
                  filtrosDecod[9].SubGrupos.push(id);
                }
                nameKey =
                  tema === "Tipo"
                    ? "Tipo"
                    : tema === "Formatos"
                    ? "Formatos"
                    : tema === "Categoría"
                    ? "Categoria"
                    : tema === "Fechas"
                    ? "Fechas"
                    : // : tema === "Grupos"
                      // ? "Grupos"
                      "";
                nameKey =
                  nameKeyGrupos === "Grupos" && dato.id_grupo ? "" : nameKey;
                if (nameKey.toString() === "Tipo") {
                  filtrosDecod[0].Tipo.push(id);
                }
                if (nameKey.toString() === "Formatos") {
                  filtrosDecod[4].Formatos.push(id);
                }
                if (nameKey.toString() === "Categoria") {
                  filtrosDecod[5].Categoria.push(id);
                }
                // if (nameKey.toString() === "Grupos") {

                // }
              }

              if (nroFiltro === 5) {
                id = dato.id_filtro;
                nameKey = "Fechas";
                filtrosDecod[6].Fechas.push(id);
              }

              if (nroFiltro === 2) {
                nameKey = "Tematicas";
                tematicaCk = dato.id_tematica;
                filtrosDecod[1].Tematicas.push(tematicaCk);
              }
              //set del filtraje armado al objeto del buscador
              let decodObject = encode64(JSON.stringify(filtrosDecod));
              setObjectBuscador((prev) => ({
                ...prev,
                filtros: decodObject,
                page: currentPage,
                min: 0,
                max: element === 0 ? rowPerPage : rowPerPage,
                idUsuario: infoUser,
                superAdmin: localStorage.getItem("superAdmin"),
              }));
            } //else para quitar las opciones des seleccionadas del array de objetos del filtro
            else {
              let dato =
                nroFiltro !== 0
                  ? JSON.parse(decode64(e.target.value))
                  : e.target.checked;
              let id;
              let tematicaCk;
              let nameKey;
              let nameKeyGrupos;
              let index;
              if (nroFiltro === 1) {
                // switch del primer filtro por formato tipo categoría check
                id =
                  tema === "Tipo"
                    ? dato.id_tipo
                    : tema === "Formatos"
                    ? dato.id_tipo_formato
                    : tema === "Categoría"
                    ? dato.id_categoria
                    : // : tema === "Grupos"
                      // ? "Grupos"
                      "";
                // if (id === "" && tema === "Grupos") {
                //   id = dato.id_grupo;

                //   if (!id) {
                //     if (!id) {
                //       id = dato.activos;
                //     }
                //     if (id === undefined) {
                //       id = dato.id_grupo_padre;
                //       filtrosDecod[8].SubGrupos.push(id);
                //     } else {
                //       filtrosDecod[7].Activos.push(id);
                //     }
                //   } else {
                //     filtrosDecod[6].Grupos.push(id);
                //   }
                // }
                nameKey =
                  tema === "Tipo"
                    ? "Tipo"
                    : tema === "Formatos"
                    ? "Formatos"
                    : tema === "Categoría"
                    ? "Categoria"
                    : // : tema === "Grupos"
                      // ? "Grupos"
                      "";
                nameKeyGrupos =
                  temaGrupos === "Grupos" && dato.id_grupo ? "Grupos" : "";
                nameKey =
                  nameKeyGrupos === "Grupos" && dato.id_grupo ? "" : nameKey;
                //remueve elementos del objeto del filtro
                if (nameKey.toString() === "Tipo") {
                  index = filtrosDecod[0].Tipo.findIndex((item) => item === id);
                  filtrosDecod[0].Tipo.splice(index, 1);
                }
                if (nameKey.toString() === "Formatos") {
                  index = filtrosDecod[4].Formatos.findIndex(
                    (item) => item === id
                  );
                  filtrosDecod[4].Formatos.splice(index, 1);
                }
                if (nameKey.toString() === "Categoria") {
                  index = filtrosDecod[5].Categoria.findIndex(
                    (item) => item === id
                  );
                  filtrosDecod[5].Categoria.splice(index, 1);
                }
                if (nameKey.toString() === "Fechas") {
                  index = filtrosDecod[6].Fechas.findIndex(
                    (item) => item === id
                  );
                  filtrosDecod[6].Fechas.splice(index, 1);
                }
                if (nameKeyGrupos.toString() === "Grupos") {
                  index = filtrosDecod[7].Grupos.findIndex(
                    (item) => item === id
                  );
                  filtrosDecod[7].Grupos.splice(index, 1);
                }
                if (typeof dato.activos !== "undefined") {
                  id = dato.activos;
                  index = filtrosDecod[8].Activos.findIndex(
                    (item) => item === id
                  );
                  filtrosDecod[8].Activos.splice(index, 1);
                }
                if (typeof dato.id_grupo_padre !== "undefined") {
                  id = dato.id_modulo;
                  index = filtrosDecod[9].SubGrupos.findIndex(
                    (item) => item === id
                  );
                  filtrosDecod[9].SubGrupos.splice(index, 1);
                }
              }

              if (nroFiltro === 5) {
                // switch del primer filtro por formato tipo categoría check
                id = dato.id_filtro;
                nameKey = "Fechas";
                index = filtrosDecod[6].Fechas.findIndex((item) => item === id);
                filtrosDecod[6].Fechas.splice(index, 1);

                // if (nameKey.toString() === "Grupos") {
                //   filtrosDecod[6].Grupos.push(id);

                //   if (!nameKey) {
                //     filtrosDecod[7].Activos.push(id);
                //   }
                //   if (nameKey === undefined) {
                //     filtrosDecod[8].SubGrupos.push(id);
                //   }

                //   //if (nameKey.toString() === "Activo") {

                //   //}
                //   //if (nameKey.toString() === "SubGrupos") {

                //   //}
                // }
              }
              // if (nroFiltro === 0) {
              //   //filtro lo mas reciente
              //   filtrosDecod[3].Reciente = [dato ? 1 : 0];
              // }
              if (nroFiltro === 2) {
                //switch del segundo filtro temátcas check
                nameKey = "Tematicas";
                tematicaCk = dato.id_tematica;
                index = filtrosDecod[1].Tematicas.findIndex(
                  (item) => item === tematicaCk
                );
                filtrosDecod[1].Tematicas.splice(index, 1);
              }
              //set del filtraje armado al objeto del buscador

              setObjectBuscador({
                ...objectBuscador,
                min: 0,
                max: element === 0 ? rowPerPage : rowPerPage,
                filtros: encode64(JSON.stringify(filtrosDecod)),
                idUsuario: infoUser,
                superAdmin: localStorage.getItem("superAdmin"),
              });
            }
          } else {
            if (nroFiltro === 4) {
              filtrosDecod[2].Orden = [e];
              //set del filtraje armado al objeto del buscador
              setObjectBuscador({
                ...objectBuscador,
                filtros: encode64(JSON.stringify(filtrosDecod)),
                min: 0,
                max: element === 0 ? rowPerPage : rowPerPage,
                idUsuario: infoUser,
                superAdmin: localStorage.getItem("superAdmin"),
              });
            } else {
              setObjectBuscador({
                ...objectBuscador,
                texto: e.target.value,
                min: 0,
                max: element === 0 ? rowPerPage : rowPerPage,
                idUsuario: infoUser,
                superAdmin: localStorage.getItem("superAdmin"),
              });
            }
          }
        } //se valida que la entrada sea del buscador del home
        if (positionSearch === "horizontal") {
          //se validan los filtros que vienen seleccionados de los filtros del buscador del home u horizontal
          if (nroFiltro !== 3) {
            //se valida es valor seleccionado
            let id = e.target ? e.target.value : e;
            if (id) {
              if (nroFiltro === 1) {
                filtrosDecod[0].Secciones = [id];
                if (id === "-1") {
                  filtrosDecod[0].Secciones = [];
                }
              }
              if (nroFiltro === 2) {
                filtrosDecod[1].Tematicas = [id];
                if (id === "-1") {
                  filtrosDecod[1].Tematicas = [];
                }
              }
              if (nroFiltro === 4) {
                filtrosDecod[2].Orden = [Number(id)];
                if (id === "-1") {
                  filtrosDecod[2].Orden = [];
                }
              }
              // console.log(filtrosDecod);

              setObjectBuscador({
                ...objectBuscador,
                filtros: encode64(JSON.stringify(filtrosDecod)),
                min: 0,
                max: element === 0 ? rowPerPage : rowPerPage,
                idUsuario: infoUser,
                superAdmin: localStorage.getItem("superAdmin"),
              });
            }
          } else {
            setObjectBuscador({
              ...objectBuscador,
              texto: e.target.value,
              min: 0,
              max: element === 0 ? rowPerPage : rowPerPage,
              idUsuario: infoUser,
              superAdmin: localStorage.getItem("superAdmin"),
            });
          }
        }
        let tipofiltroSubGruposcp = tipofiltroSubGrupos;
        if (filtrosDecod[7]?.Grupos.length > 0) {
          let tipofiltroSubGruposFiltrada = tipofiltroSubGruposcp.filter(
            (item) => filtrosDecod[7]?.Grupos.includes(item.id_grupo_padre)
          );
          if (tipofiltroSubGruposFiltrada.length > 0) {
            setTipofiltroSubGruposFiltrada(tipofiltroSubGruposFiltrada);
          } else {
            setTipofiltroSubGruposFiltrada([]);
          }
        }
        if (filtrosDecod[7]?.Grupos.length === 0) {
          setTipofiltroSubGruposFiltrada([]);
        }
      }
    } catch (error) {
      alert("Error" + error);
    }
    await cargarFiltrosGrupos();
  }

  useEffect(() => {
    let datos;
    if (localStorage.getItem("superAdmin") === "true") {
      datos = caractFiltro.resultGruposSubGruposSuperAdmin;
    } else {
      if (element === 3) {
        datos = caractFiltro.resultGruposSubGruposDocumentacion;
      } else if (element === 1) {
        datos = caractFiltro.resultGruposSubGruposGeoservicios;
      } else if (element === 7) {
        datos = caractFiltro.resultGruposSubGruposNoticias;
      } else if (element === 5) {
        datos = caractFiltro.resultGruposSubGruposAplicaciones;
      } else if (element === 2) {
        datos = caractFiltro.resultGruposSubGruposDatosAbiertos;
      } else {
        datos = caractFiltro.resultGruposSubGrupos;
      }
    }
    setTipoConsultaGrupos(datos);
  }, [infoUser]);

  // useEffect(() => {
  //   console.log("datos ", buscadorVert);
  //   debugger;
  //   let tipofiltroSubGruposcp = tipofiltroSubGruposFiltrada;
  //   let tipofiltroSubGruposFiltradaAP = tipofiltroSubGruposcp.filter((item) =>
  //     buscadorVert.some((item2) => item.id_modulo === String(item2.id_modulo))
  //   );
  //   if (tipofiltroSubGruposFiltradaAP.length > 0) {
  //     setTipofiltroSubGruposFiltrada(tipofiltroSubGruposFiltradaAP);
  //   } else {
  //     setTipofiltroSubGruposFiltrada([]);
  //   }
  // }, [buscadorVert]);
  async function cargarFiltrosGrupos() {
    let datos;
    if (localStorage.getItem("superAdmin") === "true") {
      datos = caractFiltro.resultGruposSubGruposSuperAdmin;
    } else {
      if (element === 3) {
        datos = caractFiltro.resultGruposSubGruposDocumentacion;
      } else if (element === 1) {
        datos = caractFiltro.resultGruposSubGruposGeoservicios;
      } else if (element === 7) {
        datos = caractFiltro.resultGruposSubGruposNoticias;
      } else if (element === 5) {
        datos = caractFiltro.resultGruposSubGruposAplicaciones;
      } else if (element === 2) {
        datos = caractFiltro.resultGruposSubGruposDatosAbiertos;
      } else {
        datos = caractFiltro.resultGruposSubGrupos;
      }
    }
    setTipoConsultaGrupos(datos);
  }

  //useEffect principal encargado de llenar los filtros del buscador  vertical
  useEffect(() => {
    async function aux() {
      if (element) {
        await cargarFiltrosGrupos();
        //valida el estado del elemento que tiene el buscado abierto
        if (element !== 0) {
          let esSuperAdmin = permissions.superAdmin; //localStorage.getItem("superAdmin") === "true";
          //valida el tipo de elemento para cargar los tipos de fltros
          if (element === 1) {
            setTipofiltro(
              esSuperAdmin
                ? caractFiltro.resultTiposGeo
                : caractFiltro.resultTiposGeo.filter(
                    (datosGeo) =>
                      Number(datosGeo.cantidad_geoservicios_activos) > 0
                  )
            );
            setTemticaFiltro(
              esSuperAdmin
                ? caractFiltro.resultTematicasGeoservicios
                : caractFiltro.resultTematicasGeoservicios.filter(
                    (datosGeo) => Number(datosGeo.cantidad_activos) > 0
                  )
            );
            setTema("Tipo");
            setTipofiltroGrupos(tipoConsultaGrupos);
            setTipofiltroSubGrupos(caractFiltro.resultSubGruposGeoservicios);
            setTemaSubGrupos("SubGrupos");
            setTemaGrupos("Grupos");
          }
          if (element === 5) {
            setTipofiltro(
              esSuperAdmin
                ? caractFiltro.resultTiposApp
                : caractFiltro.resultTiposApp.filter(
                    (datosApp) => datosApp.cantidad_app_activos > 0
                  )
            );
            setTemticaFiltro(
              esSuperAdmin
                ? caractFiltro.resultTematicasApp
                : caractFiltro.resultTematicasApp.filter(
                    (datosApp) => Number(datosApp.cantidad_activos) > 0
                  )
            );
            setTema("Tipo");
            setTipofiltroGrupos(tipoConsultaGrupos);
            setTipofiltroSubGrupos(caractFiltro.resultSubGruposAplicaciones);
            setTemaSubGrupos("SubGrupos");
            setTemaGrupos("Grupos");
          }
          if (element === 2) {
            setTipofiltro(
              esSuperAdmin
                ? caractFiltro.resultFormatosDa
                : caractFiltro.resultFormatosDa.filter(
                    (datoAbierto) => datoAbierto.cantidad_activos > 0
                  )
            );
            setTemticaFiltro(
              esSuperAdmin
                ? caractFiltro.resultTematicasOpendata
                : caractFiltro.resultTematicasOpendata.filter(
                    (datoAbierto) => Number(datoAbierto.cantidad_activos) > 0
                  )
            );
            setTema("Formatos");
            setTipofiltroGrupos(tipoConsultaGrupos);
            setTipofiltroSubGrupos(caractFiltro.resultSubGruposDatosAbiertos);
            setTemaSubGrupos("SubGrupos");
            setTemaGrupos("Grupos");
          }
          if (element === 3) {
            setTipofiltro(
              esSuperAdmin
                ? caractFiltro.resultCategoriasDoc
                : caractFiltro.resultCategoriasDoc.filter(
                    (datoDoc) => datoDoc.cantidad_activos > 0
                  )
            );
            setTemticaFiltro(
              esSuperAdmin
                ? caractFiltro.resultTematicasDocumentos
                : caractFiltro.resultTematicasDocumentos.filter(
                    (datoDoc) => Number(datoDoc.cantidad_activos) > 0
                  )
            );
            setTema("Categoría");
            setTipofiltroGrupos(tipoConsultaGrupos);
            setTipofiltroSubGrupos(caractFiltro.resultSubGruposDocumentacion);
            setTemaSubGrupos("SubGrupos");
            setTemaGrupos("Grupos");
          }
          //NOTICIAS
          if (element === 7) {
            setTipofiltro(
              esSuperAdmin
                ? caractFiltro.resultCategoriasNoticias.filter(
                    (dataNoticia) => Number(dataNoticia.cantidad) > 0
                  )
                : caractFiltro.resultCategoriasNoticias.filter(
                    (dataNoticia) => Number(dataNoticia.cantidad_activos) > 0
                  )
            );
            setTema("Categoría");
            setFechaFiltro(
              esSuperAdmin
                ? caractFiltro.resultFechasNoticias
                : caractFiltro.resultFechasNoticias.filter(
                    (dataNoticia) => Number(dataNoticia.cantidad_activos) > 0
                  )
            );
            setTipofiltroGrupos(tipoConsultaGrupos);
            setTipofiltroSubGrupos(caractFiltro.resultSubGruposNoticias);
            setTemaSubGrupos("SubGrupos");
            setTemaGrupos("Grupos");
          }
          //GRUPOS
          if (element === 12) {
            setTipofiltroGrupos(tipoConsultaGrupos);
            setTipofiltroActivos(caractFiltro.resultGruposSubGruposActivos);
            setTipofiltroSubGrupos(caractFiltro.resultSubGrupos);
            // setTipofiltro(esSuperAdmin ? caractFiltro.resultCategoriasNoticias : caractFiltro.resultCategoriasNoticias.filter(datoDoc => datoDoc.cantidad_activos > 0));
            // setTemticaFiltro(esSuperAdmin ? caractFiltro.resultTematicasDocumentos : caractFiltro.resultTematicasDocumentos.filter(datoDoc => Number(datoDoc.cantidad_activos) > 0));
            setTemasActivos("Activos");
            setTemaSubGrupos("SubGrupos");
            setTemaGrupos("Grupos");
          }
        }
      }
    }
    aux();
  }, [element]);

  useLayoutEffect(() => {
    if (element === 0 && buscadorHoriBool) {
      buscar();
    } else {
      if (element !== 0) {
        if (rowPerPage && rowPerPage !== 0 && !isNaN(rowPerPage)) buscar();
      }
    }
  }, [objectBuscador]);

  useEffect(() => {
    if (
      localStorage.getItem("superAdmin") === "true" ||
      localStorage.getItem("usuarioAdmin") === "true" ||
      localStorage.getItem("usuarioPublico") === "true"
    ) {
      if (infoUser) {
        setObjectBuscador((prev) => ({
          ...prev,
          page: currentPage,
          min: element === 0 ? 0 : currentPage * rowPerPage - rowPerPage,
          max: element === 0 ? rowPerPage : rowPerPage,
          superAdmin: localStorage.getItem("superAdmin"),
          idUsuario: infoUser,
          entrada: 0,
        }));
      }
    } else if (localStorage.getItem("sinUsuario") === "true") {
      setObjectBuscador((prev) => ({
        ...prev,
        page: currentPage,
        min: element === 0 ? 0 : currentPage * rowPerPage - rowPerPage,
        max: element === 0 ? rowPerPage : rowPerPage,
        superAdmin: localStorage.getItem("superAdmin"),
        idUsuario: infoUser,
        entrada: 0,
      }));
    }
  }, [currentPage, rowPerPage, element, infoUser]);

  async function buscar() {
    try {
      if (
        localStorage.getItem("superAdmin") === "true" ||
        localStorage.getItem("usuarioAdmin") === "true" ||
        localStorage.getItem("usuarioPublico") === "true"
      ) {
        if (infoUser) {
          if (typeEvent !== "keydown") {
            setLoad(true);
          }
          let objectBuscadoredit = { ...objectBuscador };
          if (objectBuscadoredit.comp === 12) {
            objectBuscadoredit.idUsuario = infoUser;
          }
          const { data, totalRows } = await getDatos(
            "geomed/buscador",
            objectBuscadoredit
          );
          if (position === "horizontal") {
            setDataBuscadorHori(data);
            setTotalRowsGlobal(totalRows);
          } else {
            setBuscadorVert(data);
          }
          setTotalRowsPagination(totalRows);
          return data;
        }
      } else {
        if (typeEvent !== "keydown") {
          setLoad(true);
        }
        let objectBuscadoredit = { ...objectBuscador };
        if (objectBuscadoredit.comp === 12) {
          objectBuscadoredit.idUsuario = infoUser;
        }
        const { data, totalRows } = await getDatos(
          "geomed/buscador",
          objectBuscadoredit
        );
        if (position === "horizontal") {
          setDataBuscadorHori(data);
          setTotalRowsGlobal(totalRows);
        } else {
          setBuscadorVert(data);
        }
        setTotalRowsPagination(totalRows);
        return data;
      }
    } catch (error) {
      alert(error);
    } finally {
      if (typeEvent !== "keydown") {
        setLoad(false);
      }
    }
  }

  function opcionesFiltro() {
    return (
      <>
        {element !== 12 && (
          <div>
            <i
              onClick={() => {
                rotate ? setRotate(false) : setRotate(true);
              }}
              className="cursor-pointer"
            >
              <MdNavigateNext
                className={
                  rotate
                    ? "icon-tipo icon-transform rotate-element-search"
                    : "icon-tipo icon-transform"
                }
              />
              <label className="check-buscador cursor-pointer">{tema}</label>
            </i>
            <Collapse in={rotate} timeout={89090}>
              <div className=" card-body content-check-filtros" id="filtro1">
                {element && element !== 0 && caractFiltro
                  ? tipofiltro.map((e, i) => {
                      return (
                        <Form.Check
                          type={"checkbox"}
                          key={`check-${e.id_tipo_formato}-${i}`}
                          value={encode64(JSON.stringify(e))}
                          onChange={(e) => {
                            changeSearchSetVal(e, position, element, 1);
                          }}
                          id={`check-filtro-${tema}-${i}`}
                          label={`${e.nombre}`}
                          className={
                            "check-filtros check-filtro chklistfiltros" +
                            element
                          }
                        />
                      );
                    })
                  : ""}
              </div>
            </Collapse>
          </div>
        )}
        {element !== 7 && element !== 12 && (
          <div>
            <i
              onClick={() => {
                rotateTematica
                  ? setrotateTematica(false)
                  : setrotateTematica(true);
              }}
              className="cursor-pointer"
            >
              <MdNavigateNext
                className={
                  rotateTematica
                    ? "icon-tipo icon-transform rotate-element-search"
                    : "icon-tipo icon-transform"
                }
              />
              <label className="check-buscador cursor-pointer">Temática</label>
            </i>
            <Collapse in={rotateTematica} timeout={89090}>
              <div className=" card-body content-check-filtros" id="filtro2">
                {element && element !== 0 && caractFiltro
                  ? temticaFiltro.map((e, i) => (
                      <Form.Check
                        type={"checkbox"}
                        key={e.id_tematica}
                        value={encode64(JSON.stringify(e))}
                        onClick={(e) => {
                          changeSearchSetVal(e, position, element, 2);
                        }}
                        id={`check-filtro-t-${e.id_tematica}`}
                        label={`${e.nombre}`}
                        className={
                          "check-filtros check-filtro chklistfiltros" + element
                        }
                      />
                    ))
                  : ""}
              </div>
            </Collapse>
          </div>
        )}
        {element === 7 && (
          <div>
            <i
              onClick={() => {
                rotateTematica
                  ? setrotateTematica(false)
                  : setrotateTematica(true);
              }}
              className="cursor-pointer"
            >
              <MdNavigateNext
                className={
                  rotateTematica
                    ? "icon-tipo icon-transform rotate-element-search"
                    : "icon-tipo icon-transform"
                }
              />
              <label className="check-buscador cursor-pointer">Fecha</label>
            </i>
            <Collapse in={rotateTematica} timeout={89090}>
              <div
                className=" card-body content-check-filtros"
                id="filtroFecha"
              >
                {element && element !== 0 && caractFiltro
                  ? fechaFiltro.map((e, i) => (
                      <Form.Check
                        type={"checkbox"}
                        key={e.id_filtro}
                        value={encode64(JSON.stringify(e))}
                        onClick={(e) => {
                          changeSearchSetVal(e, position, element, 5);
                        }}
                        id={`check-filtro-t-${e.id_filtro}`}
                        label={`${e.nombre_filtro}`}
                        className={
                          "check-filtros check-filtro chklistfiltros" + element
                        }
                      />
                    ))
                  : ""}
              </div>
            </Collapse>
          </div>
        )}
        {/* {element !== 2 && tipoConsultaGrupos.length > 1 && ( */}
        {tipoConsultaGrupos.length > 1 && (
          <div>
            <i
              onClick={() => {
                rotateGrupos ? setRotateGrupos(false) : setRotateGrupos(true);
              }}
              className="cursor-pointer"
            >
              <MdNavigateNext
                className={
                  rotateGrupos
                    ? "icon-tipo icon-transform rotate-element-search"
                    : "icon-tipo icon-transform"
                }
              />
              <label className="check-buscador cursor-pointer">
                {temaGrupos}
              </label>
            </i>
            <Collapse in={rotateGrupos} timeout={89090}>
              <div className=" card-body content-check-filtros" id="filtroG">
                {element && element !== 0 && caractFiltro
                  ? tipofiltroGrupos.map((e, i) => {
                      return (
                        <Form.Check
                          type={"checkbox"}
                          key={`check-${e.id_tipo_formato}-${i}-grupos`}
                          value={encode64(JSON.stringify(e))}
                          onChange={(e) => {
                            changeSearchSetVal(e, position, element, 1);
                          }}
                          id={`check-filtro-${tema}-${i}-grupos`}
                          label={`${e.nombre}`}
                          className={
                            "check-filtros check-filtro chklistfiltros" +
                            element
                          }
                        />
                      );
                    })
                  : ""}
              </div>
            </Collapse>
          </div>
        )}

        {/* {element !== 2 && tipoConsultaGrupos.length > 1 && ( */}
        {tipoConsultaGrupos.length > 1 && (
          <div>
            <i
              onClick={() => {
                rotateSubGrupos
                  ? setRotateSubGrupos(false)
                  : setRotateSubGrupos(true);
              }}
              className="cursor-pointer"
            >
              <MdNavigateNext
                className={
                  rotateSubGrupos
                    ? "icon-tipo icon-transform rotate-element-search"
                    : "icon-tipo icon-transform"
                }
              />
              <label className="check-buscador cursor-pointer">Subgrupos</label>
            </i>
            <Collapse in={rotateSubGrupos} timeout={89090}>
              <div className=" card-body content-check-filtros" id="filtro4">
                {element && element !== 0 && caractFiltro
                  ? tipofiltroSubGruposFiltrada?.map((e, i) => {
                      return (
                        <Form.Check
                          type={"checkbox"}
                          key={`check-sub-grupos-${i}`}
                          value={encode64(JSON.stringify(e))}
                          onChange={(e) => {
                            changeSearchSetVal(e, position, element, 1);
                          }}
                          id={`check-filtro-${temaSubGrupos}-${i}`}
                          label={`${e.nombre}`}
                          className={
                            "check-filtros check-filtro chklistfiltros" +
                            element
                          }
                        />
                      );
                    })
                  : ""}
              </div>
            </Collapse>
          </div>
        )}
        {element === 12 && (
          <div>
            <i
              onClick={() => {
                rotateActivos
                  ? setRotateActivos(false)
                  : setRotateActivos(true);
              }}
              className="cursor-pointer"
            >
              <MdNavigateNext
                className={
                  rotateActivos
                    ? "icon-tipo icon-transform rotate-element-search"
                    : "icon-tipo icon-transform"
                }
              />
              <label className="check-buscador cursor-pointer">Estado</label>
            </i>
            <Collapse in={rotateActivos} timeout={89090}>
              <div className=" card-body content-check-filtros" id="filtro3">
                {element && element !== 0 && caractFiltro
                  ? tipofiltroActivos.map((e, i) => {
                      return (
                        <Form.Check
                          type={"checkbox"}
                          key={`check-activos-${i}`}
                          value={encode64(JSON.stringify(e))}
                          onChange={(e) => {
                            changeSearchSetVal(e, position, element, 1);
                          }}
                          id={`check-filtro-${temaActivos}-${i}`}
                          label={`${e.nombre}`}
                          className={
                            "check-filtros check-filtro chklistfiltros" +
                            element
                          }
                        />
                      );
                    })
                  : ""}
              </div>
            </Collapse>
          </div>
        )}
      </>
    );
  }

  if (position === "horizontal") {
    debugger;
    return (
      <>
        <Container className="contenedor-buscar">
          <div className="contenedro-inputbuscar">
            <input
              onKeyUp={(e) => {
                changeSearchSetVal(e, position, element, 3);
              }}
              type="text"
              className="form-control iput-buscar"
              placeholder="¿Qué deseas buscar?"
            />
            <Button
              className="btn-buscar"
              onClick={() => {
                buscar();
                setBuscadorHoriBool(true);
              }}
            >
              BUSCAR AHORA
            </Button>
          </div>
          <div className="opciones-filtro">
            <div>
              <label className="lbl-opciones-busqueda">Filtros</label>
              <div className="opciones-buqsueda">
                {/* <IoRadioButtonOnSharp /> */}
                {/* <Form.Check
                  type={"radio"}
                  id={`todos`}
                  label={`Todos`}
                  className="opcion-todos"
                /> */}
                <Secciones changeSearchSetVal={changeSearchSetVal} />
                <Tematicas
                  caractFiltro={caractFiltro}
                  element={element}
                  changeSearchSetVal={changeSearchSetVal}
                />
              </div>
            </div>
            <div className="flex-order_searchGlobal">
              <i
                onClick={() => {
                  ordenar ? setOrdenar(false) : setOrdenar(true);
                }}
                className="cursor-pointer"
              >
                <label className="lbl-opciones-busqueda cursor-pointer">
                  Ordenar por
                </label>
                <BsChevronDown className="icon-ordenarpor" />
              </i>
              <div
                className={
                  ordenar
                    ? "content-opciones-orden  show"
                    : "content-opciones-orden hide"
                }
              >
                <div className="content-hijo-orden">
                  <div
                    className="cursor-pointer"
                    title="Ordenar de manera ascendente"
                    value={0}
                    onClick={(e) => {
                      changeSearchSetVal("0", position, element, 4);
                      setOrdenar(false);
                    }}
                  >
                    <ImSortAlphaAsc />
                  </div>
                  <div
                    value={1}
                    className="cursor-pointer"
                    title="Ordenar de manera descendente"
                    onClick={(e) => {
                      changeSearchSetVal("1", position, element, 4);
                      setOrdenar(false);
                    }}
                  >
                    <ImSortAlphaDesc />
                  </div>
                  {/* AQUI VAN LOS NUEVOS ORDENES */}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </>
    );
  }
  if (position === "vertical") {
    return (
      <>
        <Container fluid={true} className="conten-search-vertical ">
          <div className="inp-search">
            <input
              type={"text"}
              id="inp-search-v"
              className="input-search-vertical form-control"
              placeholder="¿Qué deseas buscar?"
              onKeyUp={(e) => {
                changeSearchSetVal(e, position, element, 3);
              }}
            />
            <i
              className="circulo-search"
              onClick={() => {
                setreRender(reRender + 1);
                buscar();
              }}
            >
              <IconButton
                className="icon-serch-vertical"
                // imagen={`${URL_IMAGE_GEOMEDELLIN}/Iconos//search.svg`}
              />
            </i>
            <div className="content-limpiar">
              <div>
                <label className="lbl-principal-buscador-vertical">
                  Filtrar búsqueda
                </label>
              </div>
              <div
                className="content-borch "
                onClick={() => {
                  limpiarFiltros();
                }}
              >
                <IconButton
                  className="icon-clear"
                  // imagen={`${URL_IMAGE_GEOMEDELLIN}/Iconos//clear.svg`}
                />
                <label className="lbl-lmp cursor-pointer">Limpiar</label>
              </div>
            </div>
            <div className="flex-filtros">{opcionesFiltro()}</div>
          </div>
          <div className="inp-result">
            <div className="content-order-search-vertical">
              <div className="flex-order_popup">
                <i
                  onClick={() => {
                    ordenar ? setOrdenar(false) : setOrdenar(true);
                  }}
                  className="cursor-pointer"
                >
                  <label className="lbl-opciones-busqueda cursor-pointer">
                    Ordenar por
                  </label>
                  <BsChevronDown className="icon-ordenarpor" />
                </i>
                <div
                  className={
                    ordenar
                      ? "content-opciones-orden-search-vertical  show"
                      : "content-opciones-orden-search-vertical hide"
                  }
                >
                  <div className="content-hijo-orden">
                    <i
                      className="cursor-pointer"
                      title="Ordenar de manera ascendente"
                      value={0}
                      onClick={(e) => {
                        changeSearchSetVal(0, position, element, 4);
                        setOrdenar(false);
                      }}
                    >
                      <span>Alfabético ascendente</span>
                      <ImSortAlphaAsc />
                    </i>
                    <i
                      className="cursor-pointer"
                      title="Ordenar de manera descendente"
                      value={1}
                      onClick={(e) => {
                        changeSearchSetVal(1, position, element, 4);
                        setOrdenar(false);
                      }}
                    >
                      <span>Alfabético descendente</span>
                      <ImSortAlphaDesc />
                    </i>

                    {element !== 7 && element !== 12 && (
                      <i
                        className="cursor-pointer"
                        title="Más prioritario"
                        value={2}
                        onClick={(e) => {
                          changeSearchSetVal(2, position, element, 4);
                          setOrdenar(false);
                        }}
                      >
                        <span>Más prioritario</span>
                      </i>
                    )}

                    {element !== 12 && (
                      <i
                        className="cursor-pointer"
                        title="Más reciente"
                        value={3}
                        onClick={(e) => {
                          changeSearchSetVal(3, position, element, 4);
                          setOrdenar(false);
                        }}
                      >
                        <span>Más reciente</span>
                      </i>
                    )}
                    {element === 2 && (
                      <i
                        className="cursor-pointer"
                        title="Más descargado"
                        value={4}
                        onClick={(e) => {
                          changeSearchSetVal(4, position, element, 4);
                          setOrdenar(false);
                        }}
                      >
                        <span>Más descargado</span>
                      </i>
                    )}
                    {element !== 12 && (
                      <i
                        className="cursor-pointer"
                        title="Más valorado"
                        value={5}
                        onClick={(e) => {
                          changeSearchSetVal(5, position, element, 4);
                          setOrdenar(false);
                        }}
                      >
                        <span>Más valorado</span>
                      </i>
                    )}

                    {element !== 12 && (
                      <i
                        className="cursor-pointer"
                        title="Más visto"
                        value={6}
                        onClick={(e) => {
                          changeSearchSetVal(6, position, element, 4);
                          setOrdenar(false);
                        }}
                      >
                        <span>Más visto</span>
                      </i>
                    )}

                    {/* <Form.Check
                      type={"checkbox"}
                      onClick={(e) => {
                        changeSearchSetVal(e, position, element, 0);
                      }}
                      id={`lomasrecientefiltro`}
                      label={`Lo más reciente`}
                      className="check-buscador"
                      defaultChecked={true}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="titulo-result top-descricpion-result-busqueda">
              <label className="lbl-titulo-result">{fraseCorta}</label>
            </div>
            <Load visible={load} />
            <Card
              component={element}
              data={buscadorVert}
              filtros={caractFiltro}
              reRender={reRender}
              buscar={buscar}
              handleLoad={handleLoad}
            />
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              idComponente={element}
              totalRows={totalRowsPagination}
              rowPerPage={rowPerPage}
              className={"pagination-padding_card"}
            />
          </div>
        </Container>
      </>
    );
  }
}
